import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import ScrollToPlugin from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

ScrollTrigger.config({ ignoreMobileResize: true });

function setNavigationTab(section, navs) {
  const target = navs.filter((nav) => nav.dataset.target === section.getAttribute('id'))[0];

  navs.forEach((nav) => {
    if (nav !== target) nav.classList.remove('active');
  });

  target.classList.add('active');
}

function scrollToSection(selector) {
  gsap.to(window, {
    duration: 1,
    scrollTo: { y: selector, offsetY: 180 }
  });
}

export default function setupArticleNavigation(classBase) {
  const article = document.querySelector(`${classBase}-content`);
  const navigation = document.querySelector(`${classBase}-navigation`);
  if (!article || !navigation) return;

  const sections = article.querySelectorAll('section');
  if (!sections || !sections.length) return;

  const navs = navigation.querySelectorAll('li');
  if (!navs || !navs.length) return;

  [...sections].forEach((section) => {
    gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: 'center bottom',
        onEnter: () => setNavigationTab(section, [...navs]),
        onEnterBack: () => setNavigationTab(section, [...navs])
      }
    });
  });

  [...navs].forEach((nav) => {
    const target = [...sections].filter(
      (section) => section.getAttribute('id') === nav.dataset.target
    )[0];

    nav.addEventListener('click', () => {
      scrollToSection(`#${target.getAttribute('id')}`);
    });
  });
}
